
import { DashboardStats, PayrollSummary } from '@/types';

// Mock Dashboard Stats
export const dashboardStats: DashboardStats = {
  totalEmployees: 5,
  activeEmployees: 4,
  totalPayrollAmount: 20500,
  averageSalary: 4100
};

// Mock Payroll Summary
export const payrollSummary: PayrollSummary[] = [
  {
    period: 'January 2023',
    totalGrossSalary: 19800,
    totalDeductions: 3960,
    totalNetSalary: 15840,
    employeesCount: 5
  },
  {
    period: 'February 2023',
    totalGrossSalary: 20300,
    totalDeductions: 4060,
    totalNetSalary: 16240,
    employeesCount: 5
  },
  {
    period: 'March 2023',
    totalGrossSalary: 20500,
    totalDeductions: 4100,
    totalNetSalary: 16400,
    employeesCount: 5
  }
];
